import React from "react";

import { MainWrapper } from "./components";
import PageOutline from "../../components/page-outline/PageOutline";

const Yummly = () => {

  return (
    <PageOutline header={{ title: "My Receipes" }}>
      <MainWrapper>
      <iframe title="yunnly-iframe" src="https://www.yummly.com/" width="100%" height="100%" frameBorder="0" allowtransparency="false" allow="encrypted-media"></iframe>
      </MainWrapper>
    </PageOutline>
  );
};

export default Yummly;
